module.exports = __webpack_public_path__ + "img/delete.9c493e01.svg";